import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty, isNil } from 'lodash'
import { Link } from 'react-router'
import Component from '../common/Component'

export class PlanMetadataComponent extends Component {
  static propTypes = {
    benefitsSet: PropTypes.object,
    configuration: PropTypes.object,
    productLine: PropTypes.string
  }

  get showPlanLink() {
    const { benefitsSet, productLine } = this.props

    const coverageLink = productLine.toLowerCase().replace(/' '/g, '_')

    return (
      <Link
        title={`${benefitsSet.vericred_id}`}
        to={`/${coverageLink}_benefits/${benefitsSet.id}`}
      >{benefitsSet.vericred_id}
      </Link>
    )
  }

  get hiosId() {
    const { benefitsSet } = this.props

    const hios = benefitsSet.plan_external_ids.filter((ids) => ids.external_id_type === 'hios_id')[0]
    return isNil(hios) ? '' : hios.external_id
  }

  get benefitState() {
    const { benefitsSet, configuration } = this.props
    const metadatum = benefitsSet.metadatum

    const value = metadatum.states || configuration.state_id.find((s) => s.value === metadatum.state_id)

    if (isNil(value) || isEmpty(value)) {
      return 'VC'
    }

    return isNil(value.text) ? value : value.text
  }

  render() {
    const { benefitsSet } = this.props
    const metadatum = benefitsSet.metadatum
    const issuer = benefitsSet.metadatum.issuer

    return (
      <div className="content">
        <nav>
          {this.newRateFactorLink}
        </nav>
        <h5>Metadata</h5>
        <table className="pure-table rate_factor_set_info">
          <tbody>
            <tr>
              <td><strong>Vericred ID</strong></td>
              <td name="vericred_id">{this.showPlanLink}</td>
            </tr>
            <tr>
              <td><strong>HIOS ID</strong></td>
              <td name="hios_id">{this.hiosId}</td>
            </tr>
            <tr>
              <td><strong>Name</strong></td>
              <td name="name">{metadatum.name}</td>
            </tr>
            <tr>
              <td><strong>Issuer</strong></td>
              <td name="issuer_id">{metadatum.carrier_id || issuer.issuer_id}</td>
            </tr>
            <tr>
              <td><strong>Carrier Brand Name</strong></td>
              <td name="carrier_brand_name">{metadatum.issuer_name || issuer.carrier_brand_name || issuer.name}</td>
            </tr>
            <tr>
              <td><strong>Line of Coverage</strong></td>
              <td name="line_of_coverage">{this.props.productLine}</td>
            </tr>
            <tr>
              <td><strong>Audience</strong></td>
              <td name="audience">{metadatum.audience}</td>
            </tr>
            <tr>
              <td><strong>State</strong></td>
              <td name="state">{this.benefitState}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default PlanMetadataComponent
